import { createContext } from 'react';

import { Page } from '@constants/enum';

export default createContext({
  pageIndex: Page.Term,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setPageIndex: (pageIndex: number) => {},
});
